module.exports = __webpack_public_path__ + "static/media/gymet_2.78c65679.png";